import React from 'react';
import { PrimaryButton } from './PrimaryButton';

export const SubmitButton = (props) => (
  <PrimaryButton
    htmlType='submit'
    {...props}
  />
);
